export var defaultIntent = 'neutral';
export var defaultLabelSize = 'medium';
export var defaultInline = false;
export var defaultGutter = false;
export var defaultLabelCols = 3;